const SCROLL_RESTORATION = 'scroll-restoration';

export const removeScrollRestoration = () => {
  sessionStorage.removeItem(SCROLL_RESTORATION);
};

export const getScrollRestoration = () => {
  const scrollTop = sessionStorage.getItem(SCROLL_RESTORATION);
  removeScrollRestoration();
  return scrollTop ? Number(scrollTop) : 0;
};

export const setScrollRestoration = (scrollTop: number) => {
  sessionStorage.setItem(SCROLL_RESTORATION, (scrollTop < 0 ? 0 : scrollTop).toString());
};
